// flow weak

import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import AnimatedView from "../../../../components";
import styles from "./style";
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin,
} from "../../../../services/fetchTools";
import { Link } from "react-router-dom";
import { withRouter } from "react-router";
import {
  Card,
  CardActions,
  CardHeader,
  CardMedia,
  CardTitle,
  CardText,
} from "material-ui/Card";
import FlatButton from "material-ui/FlatButton";
import { List, ListItem } from "material-ui/List";
import Divider from "material-ui/Divider";
import { GridList, GridTile } from "material-ui/GridList";
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from "material-ui/Table";
import RaisedButton from "material-ui/RaisedButton";
import Popover from "material-ui/Popover";
import Menu from "material-ui/Menu";
import MenuItem from "material-ui/MenuItem";
import EditIcon from "material-ui/svg-icons/image/edit";
import IconButton from "material-ui/IconButton";
import Dialog from "material-ui/Dialog";
import DeleteIcon from "material-ui/svg-icons/action/delete";
import TournamentStructure from "../tournamentStructure";
import TournamentCompetition from "../tournamentCompetition";
import AddTournamentTeam from "../viewCompetitionTeam";
import ViewFixture from "../viewFixtureSession";
import AddMatch from "../addTournamentFixture";
import AddRegistration from "../addTournamentRegistration";
import ViewCompetitionExpense from "../viewCompetitionExpense";
import ViewCompetitionGallery from "../viewCompetitionGallery";
import ViewCompetitionRegistration from "../viewCompetitionRegistration";
import moment from "moment";
import MatchList from "../viewCompetitionMatches";
import ResponseLeads from "../../responseLeads";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as actions from "../../../../redux/modules/actions";
import Modal from "react-modal";
var Spinner = require("react-spinkit");
import "./competition.css";
import {
  colors,
  btn,
  btnGroup,
  card,
  table,
  form,
  modal,
  detail,
  empty,
  spinner,
  tabs,
} from "../../../../style/common/partnerStyle";

const RegistrationStyles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "rgba(52, 52, 52, 0.8)",
  },
  content: {
    position: "null", // to override default styles
    top: "null",
    left: "null",
    right: "null",
    bottom: "null",
    background: "#fff",
    padding: "null",
    border: "null",
    maxHeight: "-webkit-fill-available",
  },
};

class ViewCompetition extends PureComponent {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func,
    }),
  };

  constructor(props) {
    super(props);
    this.state = {
      id: props.match.params.id,
      section: props.match.params.section,
      tournament: "",
      tournament: {},
      data_uploaded: false,
      data_error: false,
      venues: [],
      game_types: [],
      open: false,
      dialog_open: false,
      basicInfoView: true,
      designAndMarketingView: false,
      resigtrationView: false,
      fixtureView: false,
      galleryView: false,
      expenseView: false,
      competition_details: [],
      addNewCompetitionView: false,
      showStructure: true,
      addTeamView: true,
      addStructureView: false,
      createFixtureView: false,
      editCompetitionView: false,
      addMemberView: false,
      addExpenseView: false,
      leadView: true,
      registrationView: false,
      openModal: false,
      registrationModel: false,
      is_loading: false,
      league_match: { knockout: 0, league: 0 },
      leader_board: [],
      openLeaderBoarderPopup: false,
      leader_board_fetching: false,
      openModelForKnockoutMatches: false,
      knockout_match_duration: 0,
      game: "",
      competition_results: [],
    };
    this.getCompetition = this.getCompetition.bind(this);
    // this.handleModal = this.handleModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.handleValueChange = this.handleValueChange.bind(this);
    this.handleUnitChange = this.handleUnitChange.bind(this);
    this.getResult = this.getResult.bind(this);
  }

  handleClick = (event) => {
    // This prevents ghost click.
    event.preventDefault();
    this.setState({ open: true, anchorEl: event.currentTarget });
  };

  // handleModal=(event)=>{
  //   console.log('handleModal..')
  //   this.setState({openModal:true,registrationModel:false});
  // }
  closeModal() {
    this.setState({ openModal: false });
  }

  openRegistrationModal = (event) => {
    console.log("openRegistrationModal..");
    this.setState({ registrationModel: false }, () => {
      this.setState({ registrationModel: true });
    });
  };
  closeRegistrationModal() {
    this.setState({ registrationModel: false });
  }

  componentDidMount() {
    this.getCompetition();
    this.setState({ is_loading: true });
    if (this.state.section == "result") {
      this.getResult();
    }
  }

  getResult() {
    const url = `${getLocationOrigin()}/tournament/get_swimming_competition_results/?competition_id=${this.state.id}`;
    const options = { ...defaultOptions };
    return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .then((data) => {
        const updatedData = data.map((item) => ({
          ...item,
          value: item.result ? item.result.value : 0,
          unit: item.result ? item.result.unit : 10, // default to 'Seconds'
        }));
        this.setState({ competition_results: updatedData });
      })
      .catch((error) => error);
  }

  onTabClick(tabname) {
    if (tabname == "result") {
      this.getResult();
    }
    this.props.history.push(
      "/crud/viewCompetition/" + this.state.id + "/" + tabname,
    );
    this.setState({ section: tabname });
  }
  toAddStructureView() {
    this.setState({
      addStructureView: !this.state.addStructureView,
      createFixtureView: false,
      addMemberView: false,
    });
  }
  toEditCompetitionView() {
    this.setState({ editCompetitionView: !this.state.editCompetitionView });
  }
  onLeadView() {
    this.setState({ leadView: true, registrationView: false });
  }
  onRegistrationsView() {
    this.setState({ leadView: false, registrationView: true });
  }

  getCompetition() {
    var mobile_no = this.state.mobile_no;
    const url = `${getLocationOrigin()}/tournament/get_competition/`;
    const options = { ...defaultOptions };
    options["method"] = "post";
    options["headers"] = { "content-type": "application/json" };
    options["body"] = JSON.stringify({ competition_id: this.state.id });
    return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .then((data) =>
        this.setState({
          competition_details: data.competitions_list,
          tournament: data.competitions_list[0].tournament,
          is_loading: false,
          game: data.competitions_list[0].game,
        }),
      )
      .catch((error) => {
        console.log(error);
        alert(error.message);
      });
  }

  fetchLeaderBoard() {
    this.setState({ leader_board_fetching: true });
    const url = `${getLocationOrigin()}/tournament/get_leader_board_tournament/`;
    const options = { ...defaultOptions };
    options["method"] = "post";
    options["headers"] = { "content-type": "application/json" };
    options["body"] = JSON.stringify({ competition_id: this.state.id });
    console.log("Going to fetch");
    return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .catch((error) => {
        console.log(error);
        alert(error.message);
      })
      .then((data) => {
        console.log("dddjdddjdd");
        console.log(data);
        this.setState(
          {
            leader_board: data.leader_board,
            openLeaderBoarderPopup: true,
            leader_board_fetching: false,
          },
          () => {
            if (data.knockout_matches_created == false) {
              this.saveLeaderBoard();
            }
          },
        );
      });
  }

  saveLeaderBoard() {
    const url = `${getLocationOrigin()}/tournament/save_leader_board_tournament/`;
    const options = { ...defaultOptions };
    options["method"] = "post";
    options["headers"] = { "content-type": "application/json" };
    options["body"] = JSON.stringify({
      leader_board: this.state.leader_board,
      competition_id: this.state.id,
    });
    console.log("Going to fetch");
    return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .catch((error) => {
        console.log(error);
        alert(error.message);
      })
      .then((data) => {
        console.log("Leader board updated");
      });
  }

  getExpenseDetail = (value) => {
    this.setState({ league_match: value });
  };

  createKnockoutMatches() {
    this.setState({ leader_board_fetching: true });
    const url = `${getLocationOrigin()}/tournament/create_knockout_matches/`;
    const options = { ...defaultOptions };
    options["method"] = "post";
    options["headers"] = { "content-type": "application/json" };
    options["body"] = JSON.stringify({
      competition_id: this.state.id,
      qualified_players_no:
        parseInt(this.state.qualified_number_of_players) + 1,
      match_duration: this.state.knockout_match_duration,
    });
    console.log("Going to fetch");
    return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .catch((error) => {
        console.log(error);
        alert(error.message);
        this.setState({ leader_board_fetching: false });
      })
      .then((data) => {
        console.log("datasdfsd");
        alert(data.message);
        console.log(data);
        this.setState({ leader_board_fetching: false });
        window.location = `/#/crud/knockout-matches/${this.state.id},${"fixture"}`;
      });
  }

  changeNoOfQualifiedPeople(e) {
    this.setState({ qualified_number_of_players: e.target.value });
  }

  handleValueChange(index, newValue) {
    const updated = [...this.state.competition_results];
    updated[index].value = newValue;
    updated[index].is_changed = true;
    this.setState({ competition_results: updated });
  }

  handleUnitChange(index, newUnit) {
    const updated = [...this.state.competition_results];
    updated[index].unit = newUnit;
    updated[index].is_changed = true;
    this.setState({ competition_results: updated });
  }

  saveResult(index) {
    let row = this.state.competition_results[index];
    const url = `${getLocationOrigin()}/tournament/save_swimming_competition_results/`;
    const options = { ...defaultOptions };
    options["method"] = "post";
    options["headers"] = { "content-type": "application/json" };
    options["body"] = JSON.stringify({
      registration_id: row.id,
      score: row.value,
      unit: row.unit,
    });
    console.log("Going to fetch");
    return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .catch((error) => {
        console.log(error);
        alert(error.message);
      })
      .then((data) => {
        const updated = [...this.state.competition_results];
        updated[index].is_changed = false;
        this.setState({ competition_results: updated });
        alert(data.message);
      });
  }

  renderResult() {
    return (
      <div style={{ minHeight: 600, padding: "24px" }}>
        <div
          style={{
            fontSize: 16,
            fontWeight: 700,
            color: colors.text,
            marginBottom: 20,
            paddingBottom: 12,
            borderBottom: `1px solid ${colors.border}`,
          }}
        >
          Results
        </div>
        <div style={table.wrap}>
          <table style={table.table}>
            <thead>
              <tr>
                {[
                  "Sl.No.",
                  "Customer",
                  "Year of Birth",
                  "Mobile No.",
                  "Score/Value",
                  "Unit",
                  "",
                ].map((col) => (
                  <th key={col} style={table.th}>
                    {col}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {this.state.competition_results.map((row, index) => (
                <tr key={row.id} style={index % 2 === 1 ? table.trAlt : {}}>
                  <td style={table.tdMuted}>{index + 1}</td>
                  <td style={table.tdBold}>{row.customer}</td>
                  <td style={table.td}>{row.year_of_birth}</td>
                  <td style={table.td}>{row.contact_number}</td>
                  <td style={table.td}>
                    <input
                      type="text"
                      value={row.value}
                      onChange={(e) =>
                        this.handleValueChange(index, e.target.value)
                      }
                      style={{
                        ...form.input,
                        width: 100,
                        flex: "none",
                        minWidth: "unset",
                      }}
                    />
                  </td>
                  <td style={table.td}>
                    <select
                      value={row.unit}
                      onChange={(e) =>
                        this.handleUnitChange(index, e.target.value)
                      }
                      style={{
                        ...form.select,
                        flex: "none",
                        minWidth: "unset",
                      }}
                    >
                      {row.unit_values.map((unit) => (
                        <option key={unit.value} value={unit.value}>
                          {unit.label}
                        </option>
                      ))}
                    </select>
                  </td>
                  <td style={table.td}>
                    <button
                      style={
                        row.is_changed
                          ? btn.primary
                          : { ...btn.primary, background: colors.success }
                      }
                      onClick={() => this.saveResult(index)}
                    >
                      Save
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  render() {
    console.log("this.props");
    console.log(this.props);
    console.log(this.state.competition_details);
    const actions = [
      <FlatButton label="Cancel" primary={true} onClick={this.handleClose} />,
      <FlatButton
        label="Submit"
        primary={true}
        onClick={this.handleCustomerSubmit}
      />,
      7350005899,
    ];
    const okaction = (
      <input
        type="button"
        className="button1"
        value="Cancel"
        onClick={() => {
          this.toCreateFixtureView();
        }}
      />
    );
    var leaguekno = this.state.competition_details.filter(
      (x) =>
        x.structure == "League plus Knockout (Round robin)" ||
        x.structure == "League plus Knockout (Double round robin)",
    );
    var is_event = true;
    if (this.state.competition_details.length > 0)
      is_event =
        this.state.competition_details[0].game &&
        this.state.competition_details[0].game[1] == "Events";

    const comp = this.state.competition_details[0];

    const tabList = [
      { key: "basicInfo", label: "Info & Basic Details" },
      { key: "registrations", label: "Registrations" },
      ...(!is_event
        ? [
            comp && comp.game && comp.game[1] === "Swimming"
              ? { key: "result", label: "Result" }
              : { key: "fixture", label: "Teams & Fixture" },
            { key: "expense", label: "Expenses" },
          ]
        : []),
      { key: "gallery", label: "Gallery" },
    ];

    return (
      <div
        style={{
          fontFamily: "'DM Sans', 'Segoe UI', sans-serif",
          background: colors.bg,
          minHeight: "100vh",
          boxSizing: "border-box",
        }}
      >
        {/* Breadcrumb */}
        <div
          style={{
            padding: "14px 20px",
            display: "flex",
            alignItems: "center",
            gap: 6,
            fontSize: 13,
            color: colors.muted,
            flexWrap: "wrap",
          }}
        >
          <a
            href={"/#/partnerTournament"}
            style={{
              color: colors.brand,
              textDecoration: "none",
              fontWeight: 600,
            }}
          >
            Events
          </a>
          <span style={{ color: "#d1d5db" }}>›</span>
          <a
            style={{
              color: colors.brand,
              textDecoration: "none",
              fontWeight: 600,
              zIndex: 0,
            }}
            href={"/#/crud/viewTournament/" + this.state.tournament.id}
          >
            {this.state.tournament.name}
          </a>
          <span style={{ color: "#d1d5db" }}>›</span>
          <span
            style={{ color: colors.text, fontWeight: 600 }}
            onClick={() => {
              this.onTabClick("basicInfo");
            }}
          >
            {this.state.competition_details.length > 0 &&
              comp.category &&
              comp.age_groups &&
              comp.gender &&
              comp.category[1] +
                " " +
                comp.gender[1] +
                " " +
                comp.age_groups[1]}
          </span>
        </div>

        <div style={{ padding: "0 20px" }}>
          {/* Tab bar */}
          <div style={tabs.wrap}>
            {tabList.map((tab) => (
              <div
                key={tab.key}
                onClick={() => this.onTabClick(tab.key)}
                style={tabs.tab(this.state.section === tab.key)}
              >
                {tab.label}
              </div>
            ))}
          </div>
        </div>

        {/* Tab content */}
        <div style={{ padding: "0 20px 40px" }}>
          <div style={card.wrap}>
            {/* ── basicInfo ── */}
            {this.state.section == "basicInfo" && (
              <div>
                {/* Loading state — only shown while data is being fetched, never while edit form is open */}
                {this.state.is_loading && (
                  <div style={spinner.wrap}>
                    <Spinner
                      name="line-scale-pulse-out-rapid"
                      color={spinner.color}
                    />
                  </div>
                )}

                {/* Detail view */}
                {!this.state.is_loading &&
                  !this.state.editCompetitionView &&
                  this.state.competition_details.length > 0 && (
                    <div>
                      <div style={{ ...card.header }}>
                        <span />
                        <button
                          style={btn.outline}
                          onClick={() => this.toEditCompetitionView()}
                        >
                          ✏️ Edit Competition
                        </button>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexWrap: "wrap",
                          gap: 0,
                          ...card.bodyBordered,
                        }}
                      >
                        <div style={{ flex: "1 1 220px", paddingRight: 24 }}>
                          {[
                            {
                              label: "Organiser",
                              value:
                                comp.coordinator &&
                                comp.coordinator.map((b, i) => (
                                  <div key={i}>{b[1]}</div>
                                )),
                            },
                            {
                              label: "Start Date",
                              value: comp.start_date && comp.start_date[0],
                            },
                            {
                              label: "End Date",
                              value: comp.end_date && comp.end_date[0],
                            },
                            {
                              label: "Registrations Closed",
                              value:
                                comp.registration_closed &&
                                comp.registration_closed.length > 0 &&
                                comp.registration_closed[0],
                            },
                          ].map((row) => (
                            <div key={row.label} style={detail.row}>
                              <div style={detail.label}>{row.label}</div>
                              <div style={detail.value}>{row.value}</div>
                            </div>
                          ))}
                        </div>
                        <div style={{ flex: "1 1 220px", paddingRight: 24 }}>
                          {[
                            { label: "Game", value: comp.game && comp.game[1] },
                            ...(!comp.is_team_competition
                              ? [
                                  {
                                    label: "Gender",
                                    value: comp.gender && comp.gender[1],
                                  },
                                  {
                                    label: "Category",
                                    value: comp.category && comp.category[1],
                                  },
                                ]
                              : []),
                            {
                              label: "Age Group",
                              value: comp.age_groups && comp.age_groups[1],
                            },
                          ].map((row) => (
                            <div key={row.label} style={detail.row}>
                              <div style={detail.label}>{row.label}</div>
                              <div style={detail.value}>{row.value}</div>
                            </div>
                          ))}
                        </div>
                        <div style={{ flex: "1 1 220px" }}>
                          {[
                            {
                              label: "Venues",
                              value:
                                comp.venue &&
                                comp.venue.map((v, i) => (
                                  <div key={i}>{v[1]}</div>
                                )),
                            },
                            {
                              label: "Reg. Amount",
                              value: comp.registration_amount,
                            },
                            {
                              label: "Prize & Perks",
                              value: comp.prize_and_perks,
                            },
                          ].map((row) => (
                            <div key={row.label} style={detail.row}>
                              <div style={detail.label}>{row.label}</div>
                              <div style={detail.value}>{row.value}</div>
                            </div>
                          ))}
                        </div>
                      </div>
                      {this.state.showStructure && (
                        <TournamentStructure
                          id={this.state.tournament.id}
                          initialView={!this.state.basicInfoView}
                          competitions_id={this.state.id}
                        />
                      )}
                      <div style={{ ...card.body, display: "flex", gap: 8 }}>
                        <div style={{ ...detail.label, width: 180 }}>
                          Competition Description
                        </div>
                        <div style={{ fontSize: 13, color: colors.text }}>
                          {comp.description}
                        </div>
                      </div>
                    </div>
                  )}

                {/* Edit form */}
                {!this.state.is_loading && this.state.editCompetitionView && (
                  <div style={{ padding: "24px", background: colors.bg }}>
                    <div
                      style={{
                        maxWidth: 700,
                        margin: "0 auto",
                        background: colors.surface,
                        borderRadius: 12,
                        boxShadow:
                          "0 1px 4px rgba(0,0,0,0.08), 0 4px 16px rgba(0,0,0,0.06)",
                        overflow: "hidden",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          padding: "16px 24px",
                          borderBottom: `1px solid ${colors.border}`,
                        }}
                      >
                        <h2
                          style={{
                            margin: 0,
                            fontSize: 16,
                            fontWeight: 700,
                            color: colors.text,
                          }}
                        >
                          Edit Competition
                        </h2>
                        <button
                          style={btn.outline}
                          onClick={() => this.toEditCompetitionView()}
                        >
                          ← Back to Details
                        </button>
                      </div>
                      <TournamentCompetition
                        competitions_id={this.state.id}
                        tournament_id={this.state.tournament.id}
                        view_type="edit"
                        initialView={!this.state.basicInfoView}
                      />
                    </div>
                  </div>
                )}
              </div>
            )}

            {/* ── registrations ── */}
            {this.state.section == "registrations" && (
              <ViewCompetitionRegistration competition_id={this.state.id} />
            )}

            {/* ── marketing ── */}
            {this.state.section == "marketing" && (
              <div>
                <div style={{ ...card.header }}>
                  <span />
                  <div style={btnGroup}>
                    <button
                      style={this.state.leadView ? btn.primary : btn.outline}
                      onClick={() => this.onLeadView()}
                    >
                      Leads
                    </button>
                    <button
                      style={
                        this.state.registrationView ? btn.primary : btn.outline
                      }
                      onClick={() => this.onRegistrationsView()}
                    >
                      Registrations
                    </button>
                  </div>
                </div>
                <div style={{ padding: "20px 24px", textAlign: "center" }}>
                  {this.state.leadView && <ResponseLeads props={this.props} />}
                  {this.state.registrationView && (
                    <ViewCompetitionRegistration
                      competition_id={this.state.id}
                    />
                  )}
                </div>
              </div>
            )}

            {/* ── fixture ── */}
            {this.state.section == "fixture" && (
              <section>
                <div style={card.body}>
                  <div style={{ ...btnGroup, marginBottom: 20 }}>
                    {this.state.competition_details[0] &&
                      !this.state.competition_details[0].is_team_competition &&
                      this.state.league_match.fetch_complete &&
                      (this.state.league_match.league < 1 ||
                        this.state.league_match.knockout < 1) && (
                        <button
                          style={btn.primary}
                          onClick={() => this.openRegistrationModal()}
                        >
                          Add Registration
                        </button>
                      )}
                    {this.state.competition_details[0] &&
                      this.state.competition_details[0].is_team_competition &&
                      this.state.league_match.fetch_complete &&
                      (this.state.league_match.league < 1 ||
                        this.state.league_match.knockout < 1) && (
                        <Link to={"/crud/addCompetitionTeam/" + this.state.id}>
                          <button style={btn.primary}>Add Team</button>
                        </Link>
                      )}
                    {/*<input type="button" className="button1" style={{marginLeft:'10px'}} value="Add Match" onClick={() => {this.handleModal()}} />*/}
                    {(this.state.league_match.knockout > 0 &&
                      this.state.league_match.league < 1) ||
                    !this.state.league_match.fetch_complete ? (
                      <div />
                    ) : (
                      <Link
                        to={`/crud/addfixture/${this.state.id},${this.state.section}`}
                      >
                        <button style={btn.outline}>View Fixture</button>
                      </Link>
                    )}
                    {/*{this.state.league_match.league > 0 &&
                    <input type="button" disabled={this.state.leader_board_fetching} className="button1" style={{marginLeft:'10px'}} value="View leader board" onClick={() => {this.fetchLeaderBoard()}} />
                  }*/}
                    {leaguekno.length <= 0 &&
                      this.state.league_match.knockout > 0 && (
                        <Link
                          to={`/crud/knockout-matches/${this.state.id},${this.state.section}`}
                        >
                          <button
                            disabled={this.state.leader_board_fetching}
                            style={btn.outline}
                          >
                            View Knockout Matches
                          </button>
                        </Link>
                      )}
                  </div>

                  {
                    <Modal
                      isOpen={this.state.registrationView}
                      onRequestClose={() => {
                        this.setState({ registrationView: false });
                      }}
                      style={RegistrationStyles}
                    >
                      <div>
                        <ViewCompetitionRegistration
                          competition_id={this.state.id}
                        />
                      </div>
                      <div
                        style={{
                          padding: "16px 24px",
                          display: "flex",
                          justifyContent: "flex-end",
                        }}
                      >
                        <button
                          style={btn.danger}
                          onClick={() =>
                            this.setState({ registrationView: false })
                          }
                        >
                          Cancel
                        </button>
                      </div>
                    </Modal>
                  }

                  {this.state.addTeamView &&
                    this.state.tournament.id &&
                    !this.state.registrationView && (
                      <AddTournamentTeam
                        id={this.state.tournament.id}
                        competition_id={this.state.id}
                      />
                    )}
                </div>
                <div style={{ marginTop: 10 }}>
                  {!this.state.registrationView && (
                    <MatchList
                      noOfMatches={this.getExpenseDetail}
                      id={this.state.tournament.id}
                      competition_id={this.state.id}
                    />
                  )}
                </div>
              </section>
            )}

            {/* ── expense ── */}
            {this.state.section == "expense" && (
              <ViewCompetitionExpense competition_id={this.state.id} />
            )}

            {/* ── gallery ── */}
            {this.state.section == "gallery" && (
              <ViewCompetitionGallery competition_id={this.state.id} />
            )}

            {/* ── result ── */}
            {this.state.section == "result" && this.renderResult()}
          </div>
        </div>

        {this.state.openModal ? (
          <div>
            <Modal
              isOpen={this.state.openModal}
              onRequestClose={this.closeModal}
              style={styles.customStyles}
            >
              <button
                className="btn"
                onClick={this.closeModal}
                style={{
                  color: "red",
                  position: "absolute",
                  right: -15,
                  top: -5,
                }}
              >
                <i className="fa fa-close fa-2x"></i>
              </button>
              <AddMatch
                id={this.state.tournament.id}
                competitions_id={this.state.id}
              />
            </Modal>
          </div>
        ) : (
          ""
        )}

        {this.state.registrationModel && (
          <AddRegistration
            id={this.state.tournament.id}
            competition_id={this.state.id}
          />
        )}

        {/*{this.state.openLeaderBoarderPopup &&
          <Dialog modal={false} open={true} autoDetectWindowHeight={true} autoScrollBodyContent={true} scroll={scroll} dividers={scroll === 'paper'}>
            ...
          </Dialog>
        }*/}

        {this.state.openModelForKnockoutMatches && (
          <Dialog
            modal={false}
            open={true}
            autoDetectWindowHeight={true}
            autoScrollBodyContent={true}
            scroll={scroll}
            dividers={scroll === "paper"}
          >
            <div style={modal.dialogContent}>
              <div style={modal.dialogTitle}>Create Knockout Matches</div>
              <div style={form.row}>
                <div style={form.labelWide}>
                  {this.state.leader_board.length == 1
                    ? "How many players qualify for next knockout?"
                    : "How many players qualify from each group?"}
                </div>
                <select
                  style={form.select}
                  value={this.state.qualified_number_of_players}
                  onChange={(e) => {
                    this.changeNoOfQualifiedPeople(e);
                  }}
                >
                  <option key={-1} value={null}>
                    ..........
                  </option>
                  {Array.from({
                    length:
                      this.state.leader_board[0].group_leader_board_score
                        .length,
                  }).map((number, index) => (
                    <option key={index} value={index}>
                      {index + 1}
                    </option>
                  ))}
                </select>
              </div>
              <div style={form.row}>
                <div style={form.labelWide}>Knockout match duration (min)</div>
                <input
                  type="number"
                  style={form.input}
                  value={this.state.knockout_match_duration}
                  onChange={(e) => {
                    this.setState({ knockout_match_duration: e.target.value });
                  }}
                />
              </div>
              <div style={modal.dialogFooter}>
                <button
                  style={btn.cancel}
                  onClick={() => {
                    this.setState({ openModelForKnockoutMatches: false });
                  }}
                >
                  Cancel
                </button>
                <button
                  disabled={this.state.leader_board_fetching}
                  style={btn.primary}
                  onClick={() => {
                    this.createKnockoutMatches();
                  }}
                >
                  OK
                </button>
              </div>
            </div>
          </Dialog>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    currentView: state.views.currentView,
    statsTable: state.statsTable,
    scoreCard: state.scoreCard,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators(
      {
        enterPage: actions.enterPage,
        leavePage: actions.leavePage,
        fetchScoreCardDataIfNeeded: actions.fetchScoreCardDataIfNeeded,
        fetchStatsTableDataIfNeeded: actions.fetchStatsTableDataIfNeeded,
      },
      dispatch,
    ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ViewCompetition);



// WEBPACK FOOTER //
// ./src/app/views/partner/crud/viewCompetition/index.js